import m from "../../geodata/es2015/serbiaNoKosovoLow";
window.am4geodata_serbiaNoKosovoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/serbiaNoKosovoLow.js
// module id = null
// module chunks = 